import { CustomerStore } from "./CustomerStore";
import { CustomerListStore } from "./CustomerListStore";
import { HorseStore } from "./HorseStore";
import { HorseListStore } from "./HorseListStore";
import { SessionStore } from "./SessionStore";
import { ConfigurationStore } from "./ConfigurationStore";
import { HorseForSaleStore } from "./HorseForSaleStore";
import { HorseForSaleListStore } from "./HorseForSaleListStore";
import { ReportStore } from "./ReportStore";

import { InterceptedFetch } from "../endpoints/util/InterceptedFetch";
import { AuthEndpoints } from "../endpoints/AuthEndpoints";
import { CustomerEndpoints } from "../endpoints/CustomerEndpoints";
import { HorsesEndpoints } from "../endpoints/HorseEndpoints";
import { ConfigurationEndpoints } from "src/endpoints/ConfigurationEndpoints";
import { HorseForSaleEndpoints } from "src/endpoints/HorseForSaleEndpoints";
import { AttachmentLogEndpoints } from "src/endpoints/AttachmentLogEndpoints";
import { ReportsEndpoints } from "src/endpoints/ReportsEndpoints";

export interface StoreRepository {
    sessionStore: SessionStore;

    configurationEndpoints: ConfigurationEndpoints;
    configurationStore: ConfigurationStore;

    customerEndpoints: CustomerEndpoints;
    customerListStore: CustomerListStore;
    customerStore: CustomerStore;

    horsesEndpoints: HorsesEndpoints;
    horseStore: HorseStore;
    horseListStore: HorseListStore;

    horseForSaleEndpoints: HorseForSaleEndpoints;
    attachmentLogEndpoints: AttachmentLogEndpoints;
    horseForSaleStore: HorseForSaleStore;
    horseForSaleListStore: HorseForSaleListStore;

    reportsEndpoints: ReportsEndpoints;
    reportStore: ReportStore;
}

export default (): StoreRepository => {
    const authEndpoints = new AuthEndpoints();
    const sessionStore = new SessionStore(authEndpoints);
    const interceptedFetch = InterceptedFetch(
        () => sessionStore.authorizationString,
        token => sessionStore.updateToken(token),
        () => sessionStore.logout("Session expired.")
    );
    authEndpoints.setInterceptedFetch(interceptedFetch);

    const attachmentLogEndpoints = new AttachmentLogEndpoints(interceptedFetch);

    const configurationEndpoints = new ConfigurationEndpoints(interceptedFetch);
    const configurationStore = new ConfigurationStore(configurationEndpoints);

    const customerEndpoints = new CustomerEndpoints(interceptedFetch);
    const customerListStore = new CustomerListStore(customerEndpoints);
    const customerStore = new CustomerStore(customerEndpoints);

    const horsesEndpoints = new HorsesEndpoints(interceptedFetch);
    const horseForSaleEndpoints = new HorseForSaleEndpoints(interceptedFetch);
    const horseStore = new HorseStore(horsesEndpoints, horseForSaleEndpoints);
    const horseListStore = new HorseListStore(horsesEndpoints);

    const horseForSaleStore = new HorseForSaleStore(horseForSaleEndpoints, attachmentLogEndpoints);
    const horseForSaleListStore = new HorseForSaleListStore(horseForSaleEndpoints);

    const reportsEndpoints = new ReportsEndpoints(interceptedFetch);
    const reportStore = new ReportStore(reportsEndpoints);

    sessionStore.onLoggedIn = () => configurationStore.refresh();
    sessionStore.onLoad();

    return {
        sessionStore,
        configurationEndpoints,
        configurationStore,
        customerEndpoints,
        customerListStore,
        customerStore,
        horsesEndpoints,
        horseListStore,
        horseStore,
        attachmentLogEndpoints,
        horseForSaleEndpoints,
        horseForSaleStore,
        horseForSaleListStore,
        reportsEndpoints,
        reportStore
    };
};



// WEBPACK FOOTER //
// ./src/stores/StoreBuilder.ts